/* eslint-disable max-len */
import React from 'react'
import { connect } from 'react-redux'
import { TextInput, Label, PropertyGrid, Text, Checkbox, NumericInput } from '@leverege/ui-elements'

import { LabelGroup, IconPopover, Flex, ProjectIcon } from '~/views'
import { ProjectUpdater, BreadcrumbActions } from '~/actions'

import style from './settings.css'

class SettingsScreen extends React.Component {
  
  constructor( props ) {
    super( props )
    this.state = {}
  }

  static getDerivedStateFromProps( nextProps ) {
    nextProps.dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Settings' } ] ) )
    return {}
  }

  onProjectChange = ( path, value, err ) => {
    const { project, dispatch } = this.props

    if ( !err && project ) {
      ProjectUpdater( dispatch, project ).set( path, value )
        .done()
    }
  }

  onPasswordRequirementsChange = ( path, value, dVal ) => {
    const { project, dispatch } = this.props
    if ( typeof value === 'boolean' ) {
      if ( value === false ) {
        ProjectUpdater( dispatch, project ).set( path, value )
          .done()
      } else {
        ProjectUpdater( dispatch, project ).set( path, dVal )
          .done()
      }
      return
    }

    if ( project ) {
      ProjectUpdater( dispatch, project ).set( path, value )
        .done()
    }
  }

  render() {
    const { project } = this.props

    if ( project == null ) {
      return null
    }

    const tfa = project.twoFactorOptions?.enabled ? [
      <PropertyGrid.Item fillCell>
        <Checkbox
          label="Two-Step Authentication Required"
          value={project.twoFactorOptions?.required}
          onChange={( { value : v } ) => this.onProjectChange( 'twoFactorOptions/required', v )} />
      </PropertyGrid.Item>,
      <PropertyGrid.Item fillCell>
        <Checkbox
          label="Remember Me Enabled"
          value={project.twoFactorOptions?.rememberMeEnabled}
          onChange={( { value : v } ) => this.onProjectChange( 'twoFactorOptions/rememberMeEnabled', v )} />
      </PropertyGrid.Item>,
      <PropertyGrid.Subheader title="Supported Protocols" />,
      <PropertyGrid.Item fillCell>
        <Checkbox
          value={project.twoFactorOptions?.supportedProtocols?.email}
          label="Email"
          onChange={( { value : v } ) => this.onProjectChange( 'twoFactorOptions/supportedProtocols/email', v )} />
      </PropertyGrid.Item>,
      <PropertyGrid.Item fillCell>
        <Checkbox
          value={project.twoFactorOptions?.supportedProtocols?.sms}
          label="SMS"
          onChange={( { value : v } ) => this.onProjectChange( 'twoFactorOptions/supportedProtocols/sms', v )} />
      </PropertyGrid.Item>,
      <PropertyGrid.Item fillCell>
        <Checkbox
          value={project.twoFactorOptions?.supportedProtocols?.['authenticator-app']}
          label="Authenticator App"
          onChange={( { value : v } ) => this.onProjectChange( 'twoFactorOptions/supportedProtocols/authenticator-app', v )} />
      </PropertyGrid.Item>
    ] : []

    return (
      <PropertyGrid varaint="editor">
        <PropertyGrid.Header title="Project Settings" />
        <PropertyGrid.Item label="Project ID">
          <Text variant="code">{project.id}</Text>
        </PropertyGrid.Item>
        <PropertyGrid.Item label="Name">
          <TextInput
            size={32}
            onChange={( { value : v } ) => this.onProjectChange( 'name', v )}
            value={project.name} />
        </PropertyGrid.Item>
        <PropertyGrid.Item label="Navbar Color">
          <TextInput
            size={32}
            value={project.color}
            hint="Enter color in hex format"
            onChange={( { value : v } ) => this.onProjectChange( 'color', v )} />
        </PropertyGrid.Item>
        <PropertyGrid.Item label="Icon">
          <IconPopover
            title={(
              <Flex variant="rowM">
                <ProjectIcon
                  project={project} />
                <Text>Set Icon</Text>
              </Flex>
            )}
            value={project.icon}
            onChangeIcon={( v, err ) => this.onProjectChange( 'icon', v, err )} />
        </PropertyGrid.Item>
        <PropertyGrid>
          <PropertyGrid.Subheader title="Two-Step Authentication" />
          <PropertyGrid.Item fillCell>
            <Checkbox
              label="Two-Step Authentication Enabled"
              value={project.twoFactorOptions?.enabled}
              onChange={( { value : v } ) => this.onProjectChange( 'twoFactorOptions/enabled', v )} />
          </PropertyGrid.Item>
          {tfa}
        </PropertyGrid>
        <PropertyGrid>
          <PropertyGrid.Subheader title="Password Requirements" />
          <PropertyGrid.Item label="Min Length">
            <Flex>
              <Checkbox
                value={!!project.passwordRequirements?.minLength}
                onChange={( { value : v } ) => this.onPasswordRequirementsChange( 'passwordRequirements/minLength', v, 8 )} />
              {!!project.passwordRequirements?.minLength && (
                <NumericInput
                  value={project.passwordRequirements?.minLength}
                  onChange={( { value : v } ) => this.onPasswordRequirementsChange( 'passwordRequirements/minLength', v )} />
              )}
            </Flex>
          </PropertyGrid.Item>
          <PropertyGrid.Item label="Max Length">
            <Flex>
              <Checkbox
                value={!!project.passwordRequirements?.maxLength}
                onChange={( { value : v } ) => this.onPasswordRequirementsChange( 'passwordRequirements/maxLength', v, 64 )} />
              {!!project.passwordRequirements?.maxLength && (
                <NumericInput
                  value={project.passwordRequirements?.maxLength}
                  onChange={( { value : v } ) => this.onPasswordRequirementsChange( 'passwordRequirements/maxLength', v )} />
              )}
            </Flex>
          </PropertyGrid.Item>
          <PropertyGrid.Item label="Lowercase Characters">
            <Flex>
              <Checkbox
                value={!!project.passwordRequirements?.requireLower}
                onChange={( { value : v } ) => this.onPasswordRequirementsChange( 'passwordRequirements/requireLower', v, true )} />
              {!!project.passwordRequirements?.requireLower && (
                <NumericInput
                  value={typeof project.passwordRequirements?.requireLower === 'number' ? project.passwordRequirements?.requireLower : 1}
                  onChange={( { value : v } ) => this.onProjectChange( 'passwordRequirements/requireLower', v )} />
              )}
            </Flex>
          </PropertyGrid.Item>
          <PropertyGrid.Item label="Uppercase Characters">
            <Flex>
              <Checkbox
                value={!!project.passwordRequirements?.requireUpper}
                onChange={( { value : v } ) => this.onPasswordRequirementsChange( 'passwordRequirements/requireUpper', v, true )} />
              {!!project.passwordRequirements?.requireUpper && (
                <NumericInput
                  value={typeof project.passwordRequirements?.requireUpper === 'number' ? project.passwordRequirements?.requireUpper : 1}
                  onChange={( { value : v } ) => this.onProjectChange( 'passwordRequirements/requireUpper', v )} />
              )}
            </Flex>
          </PropertyGrid.Item>
          <PropertyGrid.Item label="Number Characters">
            <Flex>
              <Checkbox
                value={!!project.passwordRequirements?.requireNumber}
                onChange={( { value : v } ) => this.onPasswordRequirementsChange( 'passwordRequirements/requireNumber', v, true )} />
              {!!project.passwordRequirements?.requireNumber && (
                <NumericInput
                  value={typeof project.passwordRequirements?.requireNumber === 'number' ? project.passwordRequirements?.requireNumber : 1}
                  onChange={( { value : v } ) => this.onProjectChange( 'passwordRequirements/requireNumber', v )} />
              )}
            </Flex>
          </PropertyGrid.Item>
          <PropertyGrid.Item label="Special Characters">
            <Flex>
              <Checkbox
                value={!!project.passwordRequirements?.requireSpecial}
                onChange={( { value : v } ) => this.onPasswordRequirementsChange( 'passwordRequirements/requireSpecial', v, true )} />
              {!!project.passwordRequirements?.requireSpecial && (
                <NumericInput
                  value={typeof project.passwordRequirements?.requireSpecial === 'number' ? project.passwordRequirements?.requireSpecial : 1}
                  onChange={( { value : v } ) => this.onProjectChange( 'passwordRequirements/requireSpecial', v )} />
              )}
            </Flex>
          </PropertyGrid.Item>
        </PropertyGrid>
      </PropertyGrid>
    )

    return (
      <Flex variant="vSpace" direction="column" align="stretch" className={style.content}>  
        <Flex className={style.settingsHeader} direction="row" justify="space-between">
          <Text variant="screenTitle">Settings</Text>
        </Flex>
        <LabelGroup>
          <Label>Name</Label>
          <TextInput hint="Name..."
            value={project.name} 
            changeOnReturn 
            onChange={( v, err ) => this.onProjectChange( 'name', v, err )} />
        </LabelGroup>
        <LabelGroup>
          <Label>Navbar color</Label>
          <TextInput hint="#XXXXXX"
            value={project.color ? project.color : '#0f1c57'}
            changeOnReturn
            onChange={( v, err ) => this.onProjectChange( 'color', v, err )} />
        </LabelGroup>
        <LabelGroup>
          <Label>Icon</Label>
          <IconPopover
            title={(
              <Flex variant="rowM">
                <ProjectIcon
                  project={project} />
                <Text>Set Icon</Text>
              </Flex>
            )}
            value={project.icon}
            onChangeIcon={( v, err ) => this.onProjectChange( 'icon', v, err )} />
        </LabelGroup>
        <LabelGroup>
          <Label>Project ID</Label>
          <Text variant="code">{project.id}</Text>
        </LabelGroup>
      </Flex>
    )
  }
}

export default connect(
  state => ( {
    project : state.project
  } )
)( SettingsScreen )
